// types
import { DefaultConfigProps } from "./types/config";
import DefaultProfilePhoto from "assets/images/users/DefaultProfilePhoto.png";
export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";
export const fallBackProfileImage = DefaultProfilePhoto;

// Line 9:
export const APP_DEFAULT_PATH = "/admin";
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export enum SimpleLayoutType {
  SIMPLE = "simple",
  LANDING = "landing",
}

export enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export enum MenuOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export enum ThemeDirection {
  LTR = "ltr",
  RTL = "rtl",
}

export enum NavActionType {
  FUNCTION = "function",
  LINK = "link",
}

export enum DropzopType {
  DEFAULT = "default",
  STANDARD = "standard",
}

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: "default",
  themeDirection: ThemeDirection.LTR,
};


export const ApiBase: string = import.meta.env.VITE_API_URL;

export enum ClientCode {
  LocalProject = "GNLib",
  MandsaurUniversity = "MEU",
  GeetanjaliUniversity = "GET",
  GnLibrary = "GNDEMO",
  GeetanjaliJaipurUniversity = "GUJ",
  PpsuUniversity = "PPSU",
  ItmbuUniversity = "ITMBU",
  SanjivaniUniversity = "SAJ",
  JagranUniversity = "JLU",
  BbkUniversity = "BBK",
}

// ---------- URL TO CLIENT MAP ----------
export const ClientUrlMap: Record<string, ClientCode> = {
  "http://localhost:5173": ClientCode.LocalProject,
  "http://localhost:5174": ClientCode.LocalProject,
  "https://meulibrary.gnums.co.in": ClientCode.MandsaurUniversity,
  "https://www.meulibrary.gnums.co.in": ClientCode.MandsaurUniversity,
  "https://library.geetanjaliuniversity.com": ClientCode.GeetanjaliUniversity,
  "https://www.library.geetanjaliuniversity.com":
    ClientCode.GeetanjaliUniversity,
  "https://library.gnums.co.in": ClientCode.GnLibrary,
  "https://www.library.gnums.co.in": ClientCode.GnLibrary,
  "https://guj.gnlibrary.in": ClientCode.GeetanjaliJaipurUniversity,
  "https://www.guj.gnlibrary.in": ClientCode.GeetanjaliJaipurUniversity,
  "https://library.ppsu.ac.in": ClientCode.PpsuUniversity,
  "https://www.library.ppsu.ac.in": ClientCode.PpsuUniversity,
  "https://itmbu.gnlibrary.in": ClientCode.ItmbuUniversity,
  "https://www.itmbu.gnlibrary.in": ClientCode.ItmbuUniversity,
  "https://library.sanjivani.edu.in": ClientCode.SanjivaniUniversity,
  "https://www.library.sanjivani.edu.in": ClientCode.SanjivaniUniversity,
  "https://library.jlu.edu.in": ClientCode.JagranUniversity,
  "https://www.library.jlu.edu.in": ClientCode.JagranUniversity,
  "https://library.bengaluru.bbk.ac.uk": ClientCode.BbkUniversity,
  "https://www.library.bengaluru.bbk.ac.uk": ClientCode.BbkUniversity,
};

// ---------- GET CLIENTCODE FROM URL ----------
export const getClientCodeFromUrl = (url: string): ClientCode | null => {
  return ClientUrlMap[url] ?? null;
};

export const ClientDetails: Record<
  string,
  {
    Logo: string;
    Favicon?: string;
    LibraryName: string;
    CapitalizeLibraryName: string;
    ClientCode: string;
  }
> = {
  "http://localhost:5173": {
    Logo: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    LibraryName: "GN Library",
    Favicon: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    CapitalizeLibraryName: "GN LIBRARY",
    ClientCode: ClientCode.LocalProject,
  },
  "https://meulibrary.gnums.co.in": {
    Logo: "https://d1x8lnq1307h7i.cloudfront.net/Logo/Meu_SmallLogo.png",
    LibraryName: "MEU Library",
    Favicon: "https://d1x8lnq1307h7i.cloudfront.net/Logo/Meu_SmallLogo.png",
    CapitalizeLibraryName: "MANDSAUR UNIVERSITY",
    ClientCode: ClientCode.MandsaurUniversity,
  },
  "https://www.meulibrary.gnums.co.in": {
    Logo: "https://d1x8lnq1307h7i.cloudfront.net/Logo/Meu_SmallLogo.png",
    LibraryName: "MEU Library",
    Favicon: "https://d1x8lnq1307h7i.cloudfront.net/Logo/Meu_SmallLogo.png",
    CapitalizeLibraryName: "MANDSAUR UNIVERSITY",
    ClientCode: ClientCode.MandsaurUniversity,
  },
  "https://library.geetanjaliuniversity.com": {
    Logo: "https://d3kj4llxys3pxz.cloudfront.net/Logo/GeetanjaliLogo.png",
    LibraryName: "GU Library",
    Favicon: "https://d3kj4llxys3pxz.cloudfront.net/Logo/GeetanjaliLogo.png",
    CapitalizeLibraryName: "GEETANJALI UNIVERSITY",
    ClientCode: ClientCode.GeetanjaliUniversity,
  },
  "https://www.library.geetanjaliuniversity.com": {
    Logo: "https://d3kj4llxys3pxz.cloudfront.net/Logo/GeetanjaliLogo.png",
    LibraryName: "GU Library",
    Favicon: "https://d3kj4llxys3pxz.cloudfront.net/Logo/GeetanjaliLogo.png",
    CapitalizeLibraryName: "GEETANJALI UNIVERSITY",
    ClientCode: ClientCode.GeetanjaliUniversity,
  },
  "https://library.gnums.co.in": {
    Logo: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    LibraryName: "GN Library",
    Favicon: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    CapitalizeLibraryName: "GN LIBRARY",
    ClientCode: ClientCode.GnLibrary,
  },
  "https://www.library.gnums.co.in": {
    Logo: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    LibraryName: "GN Library",
    Favicon: "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
    CapitalizeLibraryName: "GN LIBRARY",
    ClientCode: ClientCode.GnLibrary,
  },
  "https://guj.gnlibrary.in": {
    Logo: "https://dxx7jww00ppub.cloudfront.net/Logo/Logo_GU_Jaipur.png",
    LibraryName: "GIMS Library",
    Favicon: "https://dxx7jww00ppub.cloudfront.net/Logo/Logo_GU_Jaipur.png",
    CapitalizeLibraryName: "GIMS Library",
    ClientCode: ClientCode.GeetanjaliJaipurUniversity,
  },
  "https://www.guj.gnlibrary.in": {
    Logo: "https://dxx7jww00ppub.cloudfront.net/Logo/Logo_GU_Jaipur.png",
    LibraryName: "GIMS Library",
    Favicon: "https://dxx7jww00ppub.cloudfront.net/Logo/Logo_GU_Jaipur.png",
    CapitalizeLibraryName: "GEETANJALI INSTITUTE OF MEDICAL SCIENCES",
    ClientCode: ClientCode.GeetanjaliJaipurUniversity,
  },
  "https://library.ppsu.ac.in": {
    Logo: "https://d2e4f9q6uak33l.cloudfront.net/Logo/PPSU_SmallLogo.jpg",
    LibraryName: "PPSU Library",
    Favicon: "https://d2e4f9q6uak33l.cloudfront.net/Logo/PPSU_SmallLogo.jpg",
    CapitalizeLibraryName: "PPSU LIBRARY",
    ClientCode: ClientCode.PpsuUniversity,
  },
  "https://www.library.ppsu.ac.in": {
    Logo: "https://d2e4f9q6uak33l.cloudfront.net/Logo/PPSU_SmallLogo.jpg",
    LibraryName: "PPSU Library",
    Favicon: "https://d2e4f9q6uak33l.cloudfront.net/Logo/PPSU_SmallLogo.jpg",
    CapitalizeLibraryName: "PPSU LIBRARY",
    ClientCode: ClientCode.PpsuUniversity,
  },
  "https://itmbu.gnlibrary.in": {
    Logo: "https://d3s4guf33nwqf8.cloudfront.net/Logo/ITMBU_Logo.png",
    LibraryName: "ITMBU Library",
    Favicon: "https://d3s4guf33nwqf8.cloudfront.net/Logo/ITMBU_Logo.png",
    CapitalizeLibraryName: "ITMBU LIBRARY",
    ClientCode: ClientCode.ItmbuUniversity,
  },
  "https://www.itmbu.gnlibrary.in": {
    Logo: "https://d3s4guf33nwqf8.cloudfront.net/Logo/ITMBU_Logo.png",
    LibraryName: "ITMBU Library",
    Favicon: "https://d3s4guf33nwqf8.cloudfront.net/Logo/ITMBU_Logo.png",
    CapitalizeLibraryName: "ITMBU LIBRARY",
    ClientCode: ClientCode.ItmbuUniversity,
  },
  "https://library.sanjivani.edu.in": {
    Logo: "https://assets.sanjivani.gnlibrary.in/Logo/SJU_SmallLogo.jpg",
    LibraryName: "SU Library",
    Favicon: "https://assets.sanjivani.gnlibrary.in/Logo/SJU_SmallLogo.jpg",
    CapitalizeLibraryName: "SANJIVANI LIBRARY",
    ClientCode: ClientCode.SanjivaniUniversity,
  },
  "https://www.library.sanjivani.edu.in": {
    Logo: "https://assets.sanjivani.gnlibrary.in/Logo/SJU_SmallLogo.jpg",
    LibraryName: "SU Library",
    Favicon: "https://assets.sanjivani.gnlibrary.in/Logo/SJU_SmallLogo.jpg",
    CapitalizeLibraryName: "SANJIVANI LIBRARY",
    ClientCode: ClientCode.SanjivaniUniversity,
  },
  "https://library.jlu.edu.in": {
    Logo: "https://d2w8re05n1krxj.cloudfront.net/Logo/JLU_SmallLogo.jpg",
    LibraryName: "JLU Library",
    Favicon: "https://d2w8re05n1krxj.cloudfront.net/Logo/JLU_SmallLogo.jpg",
    CapitalizeLibraryName: "JLU LIBRARY",
    ClientCode: ClientCode.JagranUniversity,
  },
  "https://www.library.jlu.edu.in": {
    Logo: "https://d2w8re05n1krxj.cloudfront.net/Logo/JLU_SmallLogo.jpg",
    LibraryName: "JLU Library",
    Favicon: "https://d2w8re05n1krxj.cloudfront.net/Logo/JLU_SmallLogo.jpg",
    CapitalizeLibraryName: "JLU LIBRARY",
    ClientCode: ClientCode.JagranUniversity,
  },
  "https://library.bengaluru.bbk.ac.uk": {
    Logo: "https://d1coxj52yhw8yt.cloudfront.net/Logo/BBK_FullLogo.png",
    Favicon: "https://d1coxj52yhw8yt.cloudfront.net/Logo/BBK_Favicon.jpeg",
    LibraryName: "",
    CapitalizeLibraryName: "",
    ClientCode: ClientCode.BbkUniversity,
  },
  "https://www.library.bengaluru.bbk.ac.uk": {
    Logo: "https://d1coxj52yhw8yt.cloudfront.net/Logo/BBK_FullLogo.png",
    Favicon: "https://d1coxj52yhw8yt.cloudfront.net/Logo/BBK_Favicon.jpeg",
    LibraryName: "",
    CapitalizeLibraryName: "",
    ClientCode: ClientCode.BbkUniversity,
  },
};

export function getClientDetails(url: string) {
  if (!url) return ClientDetails["http://localhost:5173"];
  const normalized = url.replace(/\/$/, "");
  return (
    ClientDetails[normalized] ??
    ClientDetails[url] ??
    (url.includes("localhost") || url.includes("127.0.0.1")
      ? ClientDetails["http://localhost:5173"]
      : null)
  );
}

export default config;
